var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"left":"","max-width":"200"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"color":"primary","dark":""}},on),[_vm._v(" mdi-exclamation ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.$t('cms.tracking.trackingSensitiveMark')))])])}
var staticRenderFns = []

export { render, staticRenderFns }